import { SelectOption } from 'modules/queryBuilder/contexts';
import { AnyComparator, FieldType } from 'modules/queryBuilder/types';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { useTranslation } from '../../../../hooks';
import { CATALOG_IN_SEGMENTATION_FEATURE_FLAG } from '../../../../featureFlags';

export const useOptionsWithMatchesCatalog = (
  options: SelectOption<AnyComparator>[],
  fieldType?: FieldType,
) => {
  const { t } = useTranslation();
  const isFeatureFlagged = useFeatureFlag(CATALOG_IN_SEGMENTATION_FEATURE_FLAG);
  const MatchesCatalogOption = {
    value: 'MatchesCatalogData',
    title: t('comparators.matchesCatalogDataComparator'),
  };
  if (!isFeatureFlagged) return options;

  switch (fieldType) {
    case FieldType.STRING:
    case FieldType.KEYWORD:
    case FieldType.INTEGER:
    case FieldType.FLOAT:
    case FieldType.BOOLEAN:
    case FieldType.DATE:
      return [MatchesCatalogOption, ...options];
    default:
      return options;
  }
};
